import type { VoucherFormValues } from 'app/components/pages/Bookings/BookingDetails/_hooks/useVoucherActions';
import type { BookingDetails } from 'app/typings/core/admin/bookings/booking';
import type {
  CreateBookingVoucherForm,
  UpdateBookingVoucherForm,
} from 'app/typings/core/admin/bookings/bookingForm';
import type { CreateBookingRefundForm } from 'app/typings/core/admin/bookings/bookingRefundForm';

export const mapToCreateBookingVoucher = (
  voucher: VoucherFormValues,
  bookingDetails: BookingDetails
): CreateBookingVoucherForm => {
  const { id, hotel, userData } = bookingDetails;

  return {
    bookingId: id,
    countryId: hotel.countryId,
    value: voucher.value,
    userId: userData.id,
    expirationDate: voucher.expirationDate.format('YYYY-MM-DD'),
    reasonType: voucher?.reasonType || 'OTHER',
    comment: voucher?.comment,
  };
};

export const mapToUpdateBookingVoucher = (
  voucher: VoucherFormValues
): UpdateBookingVoucherForm => {
  return {
    value: voucher.value,
    expirationDate: voucher.expirationDate.format('YYYY-MM-DD'),
    reasonType: voucher?.reasonType || 'OTHER',
    comment: voucher?.comment,
  };
};

export const mapBookingRefundCreation = (
  refund: Omit<CreateBookingRefundForm, 'bookingId' | 'userId'>,
  bookingId: number,
  userId: number
): CreateBookingRefundForm => {
  return {
    ...refund,
    bookingId,
    userId,
  };
};
